import { render, staticRenderFns } from "./sky-richtext.vue?vue&type=template&id=c94160b8&scoped=true"
import script from "./sky-richtext.vue?vue&type=script&lang=js"
export * from "./sky-richtext.vue?vue&type=script&lang=js"
import style0 from "./sky-richtext.vue?vue&type=style&index=0&id=c94160b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94160b8",
  null
  
)

export default component.exports